import React from "react";
import PropTypes from "prop-types";

import Modal from "../../Modal";

class NotesModal extends React.Component {
  state = { notes: this.props.notes };

  handleChangeNotes = e => this.setState({ notes: e.target.value });

  handleClick = () => {
    const { notes } = this.state;
    const { onDone } = this.props;

    onDone(notes);
  };

  componentWillReceiveProps(nextProps) {
    this.setState({notes: nextProps.notes})
  }

  render() {
    const { notes } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Modal title="Notes" visible={visible} onClose={onClose}>
        <div>
          <div>
            <textarea
              className="form-control"
              value={notes || ""}
              onChange={this.handleChangeNotes}
            />
          </div>
          <br/>

          <button
            className="btn btn-pink btn-block btn-raised"
            onClick={this.handleClick}
          >
            CONFIRM
          </button>
        </div>
      </Modal>
    );
  }
}

NotesModal.propTypes = {
  notes: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  onDone: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

NotesModal.defaultProps = {
  notes: ""
};

export default NotesModal;
